import * as React from 'react';
import { styled } from '@mui/system';

const HorizontalLineWithDiamondShapeInMiddle = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  gap: '11px',
  margin: '20px 18px 0',
  position: 'relative',
});

const TitleLine = styled('span')(({ theme }) => ({
  width: 'calc(50% - 20px)',
  borderBottom: '2px solid rgb(166,146,123)',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const Diamond = styled('div')(({ theme }) => ({
  color: 'rgb(166,146,123)',
  marginBottom: '-12px',
  [theme.breakpoints.down('sm')]: {
    '&, &+span': {
      display: 'none',
    },
  },
}));

const DiamondLine = () => {
  return (
    <HorizontalLineWithDiamondShapeInMiddle>
      <TitleLine />
      <Diamond>♦</Diamond>
      <TitleLine />
    </HorizontalLineWithDiamondShapeInMiddle>
  );
};

export default DiamondLine;
